import React, {useEffect, useState} from "react";
import success from '../../images/success.png';
import fail from '../../images/fail.png';
import { parse } from "qs";
import {useHistory, useLocation} from "react-router";
import {useLoading} from "../../components/loading/LoadingProvider";
import {getTradesResult} from "../../service";

function getIsWxClient() {
    const ua = navigator.userAgent.toLowerCase();
    // @ts-ignore
    if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true;
    }
    return false;
}

type Result = {
    success:boolean,
    totalFee:number,
    tradeId:string
}

function BackToWx(){

    const location = useLocation()
    const loading = useLoading()
    const { tradeId,userId } = parse(location.search.replace(/\?/,''))
    const [status,setStatus] = useState<Result>()
    const { goBack } = useHistory()

    useEffect(() => {

        if(tradeId && userId){
            loading.showLoading('查询中...')
            setTimeout(() => {
                getTradesResult({
                    userId:(userId as string),
                    tradeId:(tradeId as string)
                }).then(res => {
                    loading.hideLoading()
                    if(res.code === 1){
                        setStatus(res.data)
                    }else{
                        setStatus({
                            success:false,
                            totalFee:0,
                            tradeId:(tradeId as string)
                        })
                    }
                })
            },3000)

        }
    },[tradeId,userId])

    if(!status) return null

    return <div className="back-wx">
        {
            status.success ? <>
                <img src={ success } alt=""/>
                {/*<h3>￥{ priceConvert(status.totalFee) }元</h3>*/}
                <p>支付成功</p></>
                :
                <>
                    <img src={ fail } alt=""/>
                    {/*<h3>￥{ priceConvert(status.totalFee) }元</h3>*/}
                    <p>支付失败</p>
                </>
        }
        {
            getIsWxClient() ? <p onClick={ goBack } className='a'>返回TIBA</p> : <a className='a' href="weixin://">返回TIBA</a>
        }

    </div>
}

export default BackToWx
